'use strict';

var EXPIRY_TIME = 300;
var GET_SIGNED_URL_API = "v1/normal-get-upload";
var url_required_for_keys = {
    GET: "GET",
    UPLOAD: "UPLOAD",
};

exports.EXPIRY_TIME = EXPIRY_TIME;
exports.GET_SIGNED_URL_API = GET_SIGNED_URL_API;
exports.url_required_for_keys = url_required_for_keys;
//# sourceMappingURL=S3.constants.js.map
